import React from 'react';
import Icon from './Icon';

const VariantOptionLabel = ({
  label,
  stockStatus,
  inStock,
  stockDescription,
}) => {
  return (
    <div className="flex justify-between items-center">
      <span className="label">{label}</span>
      {stockStatus > 0 && inStock ? (
        <span className="flex items-center svg:mr-1">
          <Icon name={'check-circle'} />
          {stockDescription}
        </span>
      ) : stockStatus < 1 && inStock ? (
        <span className="flex items-center svg:mr-1">
          <Icon name={'check-circle-orange'} />
          {stockDescription}
        </span>
      ) : (
        <span className="flex items-center svg:mr-1">
          <Icon name={'cross-circle'} />
          {stockDescription}
        </span>
      )}
    </div>
  );
};
export default VariantOptionLabel;
